import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useInfiniteQuery } from '@tanstack/react-query';
import { RolesApiAdapter } from '../adapters/RolesApiAdapter';
import { Filters } from '../models/Filters';
import { Service } from '../services/Service';

export const useRoles = (filters: Filters = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new RolesApiAdapter(httpClient);
  const service = new Service(apiAdapter);

  const {
    data,
    isLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isPending,
  } = useInfiniteQuery({
    queryKey: ['roles', filters],
    queryFn: ({ pageParam = 1 }) =>
      service.getPaginated({
        ...filters,
        page: pageParam,
      }),
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
    staleTime: 5 * 60 * 1000,
  });

  const roles = data?.pages.flatMap((page) => page.roles) ?? [];

  // Obtener el total del API (siempre sera el mismo en todas las paginas)
  const totalFromApi = data?.pages?.[0]?.total ?? 0;

  return {
    roles,
    isLoading: isLoading || isPending,
    error,
    refetch,
    // Nuevas props para scroll infinito
    fetchNextPage,
    hasNextPage: hasNextPage ?? false,
    isFetchingNextPage,
    isFetching,
    // Stats útiles
    totalPages: data?.pages.length ?? 0,
    totalLocations: roles.length,
    total: totalFromApi, // Total real del API
  };
};
